<template>
  <div :id="chartId" ref="charts" class="chart"></div>
</template>
<script>
import { initResizeListener } from '@/utils/utils';

export default {
  name: 'charts',
  props: {
    resize: {
      type: [String, Number, Boolean],
      default: -1,
    },
    chartId: {
      type: String,
      default: 'chart',
    },
    options: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      dom: null,
      colors: [],
      charts: '',
      redener: 0,
    };
  },
  beforeRouteLeave(to, from, next) {
    this.charts.dispose();
    this.charts = null;
    this.dom = null;
    next();
  },
  created() {
  },
  mounted() {
    this.dom = this.$refs.charts;
    this.dom.addEventListener('resize', this.resizeMap);
    if (!this.charts) {
      this.initChart();
    }
    this.setOptions();
  },
  beforeDestroy() {
    this.dom = null;
    this.resizeMap = null;
    this.initChart = null;
    this.setOptions = null;
  },
  watch: {
    resize() {
      this.$nextTick(() => {
        this.resizeMap();
      });
    },
    options: {
      deep: true,
      handler() {
        this.charts.clear();
        console.log('options', this.options);
        if (!this.charts) {
          this.initChart();
        }
        this.setOptions();
      },
    },
  },
  methods: {
    initChart() {
      this.charts = this.$echarts.init(this.dom);
      initResizeListener(this.charts, this.$refs.charts);
    },
    resizeMap() {
      this.charts.resize();
    },
    setOptions() {
      if (!this.options) {
        return;
      }
      this.charts.setOption(this.options);
      this.charts.resize();
    },
  },
};
</script>
<style scoped>
</style>
